import 'css-chunksrc/client/common/secondaryCriteriaIcon/styles.scss';export default {
  "listIcon": "_listIcon_1p4j4_1"
};